// SelectBuilding.tsx
import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Search, MoreVertical, Home, ArrowLeft, Files } from 'lucide-react';
import BottomNav from '../../components/BottomNav.tsx';
import { digitalOceanImageUrl } from "../../utils/digitalOcean.ts";

interface Building {
  id: number;
  building_name: string;
}

const SelectBuilding: React.FC = () => {
  const [buildings, setBuildings] = useState<Building[]>([]);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const vehicleModelId = searchParams.get("vehicleModelId");

  useEffect(() => {
    fetch("http://172.16.101.250:4500/api/buildings")
      .then((res) => res.json())
      .then((data) => {
        // Adjust if your API returns an object instead of an array.
        setBuildings(Array.isArray(data) ? data : data.buildings || []);
      })
      .catch((err) => console.error("Error fetching buildings:", err));
  }, []);

  const handleSelectBuilding = (buildingId: number) => {
    // Navigate to the Add Work Station page.
    navigate(`/add-work-station/${buildingId}/${vehicleModelId}`);
  };

  return (
    <div className="min-h-screen bg-blue-900 ">
     {/* Header */}
          <div className="p-4 "><img src={digitalOceanImageUrl("new%20logos/Asset%204.png")} alt="KMC Logo" className="w-16 h-auto ml-auto h-24 w-27 " />  </div>
            <div className="p-6 flex justify-between items-center">
              <h1 className="text-white text-lg font-medium">
                Create Vehicle Model Here
              </h1>
            </div>
    
          {/* Search Bar */}
          <div className="px-6 mb-6">
            <div className="relative">
              <input
                type="text"
                placeholder="Search for an instruction document..."
                className="w-full py-3 px-4 pr-10 rounded-full"
              />
              <Search className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400" />
            </div>
          </div>
              <div className="bg=white rounded-3xl">
               <div className=" mb-6 bg-white rounded-3xl p-6">
                <div className="bg-white rounded-xl border p-8 flex justify-between items-center">
                      <div>
                          <h2 className="text-blue-900 text-xl font-bold mb-2">Building Selection</h2>
                          <p className="text-gray-600 text-sm max-w-xs">
                          Please select the building where the vehicle model will be assembled. </p>
                      </div>
                      <img src={digitalOceanImageUrl("assets/images/menatwork.png")} alt="12M EVS" className="w-27 h-24" />
                    </div>
              
              
            <div className="bg-white p-8 rounded-lg w-full ">
              <h1 className="text-2xl text-blue-900 font-bold mb-4">Select Building</h1>
              <div className="space-y-3 w-full">
                {buildings.map((b) => (
                  <div
                    key={b.id}
                    onClick={() => handleSelectBuilding(b.id)}
                    className="w-full  p-4 border rounded-xl font-semibold mb-4 cursor-pointer bg-sky-200 hover:bg-sky-300"
                  >
                    {b.building_name}
                  </div>
                ))}
              </div>
            </div>
          
            <BottomNav 
              showBack={true}/>
            </div>
            </div>
    </div>
  );
};

export default SelectBuilding;
